module.exports = __webpack_public_path__ + "img/room5.f76a5c0d.gif";